function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

// For D2C client, the validator is Ajv validator function which contains errors property.
function handleError(msg, validator) {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  if (validator && validator.errors) {
    throw new Error("".concat(validator.errors[0].instancePath, " - ").concat(validator.errors[0].message));
  } else {
    throw new Error(msg);
  }
} // Get common data properties and values from the event data

function getCommonFromEvent(eventData, commonData) {
  var common = {};
  Object.keys(eventData).forEach(function (k) {
    if (Object.keys(commonData).includes(k)) {
      common[k] = eventData[k];
    }
  });
  return common;
}

var DataLayer = /*#__PURE__*/function () {
  function DataLayer() {
    _classCallCheck(this, DataLayer);
  }

  _createClass(DataLayer, null, [{
    key: "init",
    value: function init(opts) {
      // We do not want to instantiate DataLayer more than once.
      if (!DataLayer.initiated) {
        DataLayer.initiated = true;
        DataLayer.data = {
          events: []
        };
        DataLayer.validateCommon = opts && opts.validateCommon || null;
        DataLayer.validateEvent = opts && opts.validateEvent || null;
        DataLayer.commonSchema = opts && opts.commonSchema || null;
      }
    } // Update common properties in the data layer.

  }, {
    key: "updateCommon",
    value: function updateCommon(data) {
      // validateCommon is not provided or data is valid
      if (!DataLayer.validateCommon || DataLayer.validateCommon(data)) {
        DataLayer.data = Object.assign(DataLayer.data, data);
      } else {
        handleError('Data error with common data', DataLayer.validateCommon);
      }
    } // Push event data to the data layer.
    // If commonSchema is provided and commonSchema properties are found in the event data,
    // those properties and values are updated in the data layer.

  }, {
    key: "pushEvent",
    value: function pushEvent(data) {
      // validateEvent is not provided or data is valid
      if (!DataLayer.validateEvent || DataLayer.validateEvent(data)) {
        if (DataLayer.commonSchema && DataLayer.commonSchema.properties) {
          // Get common data from event data
          var common = getCommonFromEvent(data, DataLayer.commonSchema.properties); // Update CommonData in the data layer

          Object.assign(DataLayer.data, common); // Get CommonData and add it to event data

          Object.assign(data, this.getCommonData());
        }

        Array.prototype.push.apply(DataLayer.data.events, [data]);
      } else {
        handleError('Data error with event data', DataLayer.validateEvent);
      }
    } // Get only common data from the data layer

  }, {
    key: "getCommonData",
    value: function getCommonData() {
      var commonData = _objectSpread2({}, DataLayer.data);

      delete commonData.events;
      return commonData;
    } // Get the data layer object

  }, {
    key: "getData",
    value: function getData() {
      return DataLayer.data;
    } // This function removes all event data and common data in the DataLayer

  }, {
    key: "resetData",
    value: function resetData() {
      DataLayer.data = {
        events: []
      };
    }
  }]);

  return DataLayer;
}();

_defineProperty(DataLayer, "commonSchema", void 0);

_defineProperty(DataLayer, "validateEvent", void 0);

_defineProperty(DataLayer, "validateCommon", void 0);

_defineProperty(DataLayer, "data", void 0);

_defineProperty(DataLayer, "initiated", void 0);

export { DataLayer };
//# sourceMappingURL=index.js.map
